































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import CreatePaymentOrderRequest from '@/models/Accounts/Shared/PaymentOrders/CreatePaymentOrderRequest';
import PaymentType from '@/models/Accounts/Shared/Payments/PaymentType';
import ScheduleFrequency from '@/models/Shared/ScheduleFrequency';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'PaymentOrderPaymentDetails' })
export default class extends SaascadaVueDialog {

    @Prop({required: true})
    request: CreatePaymentOrderRequest;

    @Prop({required: true})
    minEndDateAsString: string;

    @Prop({required: true})
    paymentType: PaymentType;

    @Prop({required: true})
    schemes: [];

    @Prop({required: true})
    tomorrowsDateAsString: string;

    @Prop({required: true})
    paymentReference: string;

    @Prop({required: true})
    amountAsNumber: number;

    @Prop({required: true})
    currency: string;

    PaymentType = PaymentType;

    get yearInFutureDateAsAString() {
        // Calculate the max date for schedule start which is one year from tomorrow
        const initialDate = new Date(this.tomorrowsDateAsString);
        initialDate.setFullYear(initialDate.getFullYear() + 1);
        return initialDate.toISOString().split('T')[0];
    }

    get scheduleFrequencyOptions() {
        return ListUtils.scheduleFrequencyOptions();
    }

    changePaymentType(paymentType: PaymentType) {
        this.$emit('inputPaymentType', paymentType);
    }

    changeScheduleFrequency(scheduleFrequency: ScheduleFrequency) {
        this.$emit('inputScheduleFrequency', scheduleFrequency);
    }

    changeScheduleStartDate(startDate: string) {
        this.$emit('inputScheduleStartDate', startDate);
    }

    changeScheduleEndDate(endDate: string) {
        this.$emit('inputScheduleEndDate', endDate);
    }

    changeSelectedScheme(scheme: string) {
        this.$emit('inputScheme', scheme);
    }

    changePaymentReference(paymentReference: string) {
        this.$emit('inputPaymentReference', paymentReference);
    }

    changeAmount(amount: number) {
        this.$emit('inputAmount', amount);
    }

}
